import * as React from 'react'
import { observer } from 'mobx-react'

import { Section, SectionItem } from '../../components/Section'
import PersonalProfileViewModel from '../PersonalProfile/PersonalProfileViewModel'
import { PhysicalAddressSectionItems } from 'jobs/info-gathering/components/PhysicalAddress'
import { ContactInfoSectionItems } from 'jobs/info-gathering/components/ContactInfo'
import SectionEmptyState from 'jobs/info-gathering/components/SectionEmptyState'
import EditPersonalProfileDialog from 'jobs/views/JobRoot/Job/CapturedInformationCard/EditPersonalProfileDialog'
import EditPersonalProfileDialogViewModel from 'jobs/views/JobRoot/Job/CapturedInformationCard/EditPersonalProfileDialog/EditPersonalProfileDialogViewModel'
import Button from 'components/Button'

interface Props {
  vm: PersonalProfileViewModel
  editVM?: EditPersonalProfileDialogViewModel
  canEdit?: boolean
}

export default observer(function PersonalProfile({
  vm,
  editVM,
  canEdit,
}: Props) {
  const profile = vm.profile
  const editable = Boolean(canEdit && editVM)

  if (!vm.personalInfoSupportingItem) {
    return <></>
  }

  if (!profile && !editable) {
    return <></>
  }

  return (
    <>
      {!profile && editVM && (
        <SectionEmptyState
          title="No general info yet"
          actionLabel="Fill in general info"
          onAction={() => editVM.show()}
          data-test="personal-profile-empty-state-action"
        />
      )}
      {profile && (
        <>
          <Section
            title="Personal Information"
            loading={vm.activate.pending}
            actions={
              editable && editVM ? (
                <Button
                  type="text"
                  onClick={() => editVM.show()}
                  data-test="update-personal-information-button"
                >
                  Edit
                </Button>
              ) : undefined
            }
          >
            <SectionItem label="Name" value={profile?.personalInfo?.fullName} />

            <SectionItem
              label="Date of birth"
              value={profile?.personalInfo?.dateOfBirth}
              isSensitive
            />

            <SectionItem
              label="Occupation"
              value={profile?.occupation}
              isSensitive
            />

            <SectionItem
              label="SSN or ITIN"
              value={
                profile?.personalInfo?.personalTaxpayerIdentificationNumber
              }
              maskedValue={
                profile?.personalInfo
                  ?.personalTaxpayerIdentificationNumberDisplay
              }
              isSensitive
            />
          </Section>

          <Section
            title="Contact Information"
            loading={vm.activate.pending}
            bordered
          >
            <ContactInfoSectionItems vm={profile?.contactInfo} />
            <PhysicalAddressSectionItems vm={profile?.contactInfo} />
          </Section>
        </>
      )}
      {editVM && <EditPersonalProfileDialog vm={editVM} />}
    </>
  )
})
